'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACT',
    link: '/contact'
  }, {
    text: 'LOGIN',
    link: ''
  }],
  loginLink: {
    text: 'LOGIN',
    src: ''
  },
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense',
      src: '/expense-management'
    }, {
      text: 'Intelligence',
      src: '/business-intelligence'
    }, {
      text: 'Invoice',
      src: '/invoice-management'
    }, {
      text: 'Locate',
      src: '/concur-locate'
    }, {
      text: 'Messaging',
      src: '/risk-messaging'
    }, {
      text: 'Travel & Expense',
      src: '/travel-expense'
    }, {
      text: 'Travel Booking',
      src: '/travel-booking'
    }]
  }, {
    title: {
      text: 'FEATURES'
    },
    list: [{
      text: 'Mobile App',
      src: '/mobile'
    }, {
      text: 'Compliance',
      src: '/compliance'
    }, {
      text: 'Audit',
      src: '/expense-audit'
    }, {
      text: 'Software Integration',
      src: '/financial-connectors'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Platform',
      src: '/concur-integrated-ecosystem'
    }, {
      text: 'Why Concur',
      src: '/why-concur'
    }, {
      text: 'Offices Locations',
      src: '/contact/offices'
    }, {
      text: 'Careers',
      src: ''
    }, {
      text: 'Contact Sales',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Events',
      src: '/events'
    }, {
      text: 'Resource Centre',
      src: '/resource-centre'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }, {
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'Case Studies',
      src: '/casestudy'
    }, {
      text: 'Expense Demo',
      src: '/self-guided-demo-expense',
      classes: 'call-out hidden-xs hidden-sm hidden-md'
    }, {
      text: 'Invoice Demo',
      src: '/self-guided-demo-invoice',
      classes: 'call-out hidden-xs hidden-sm hidden-md'
    }]
  }],
  supportLinks: [{
    text: 'CONCUR BLOG',
    href: '/newsroom'
  }, {
    text: 'CONTACT',
    href: '/contact'
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};